
import React from "react";
import Mainheader from "../components/MainHeader/Mainheader";
import Footer from "../components/Footer/Footer";

const DocumentationScan = () => {
  return (
    <div className="Main">
      <Mainheader />
      <div className="Fullbody">
        <div className="condion_content_section">
          <h3>Privacy Policy</h3>
          <div className="condion_inner_content_section">
            <h4>Overview</h4>
            <p>
              This application is designed for healthcare professionals using our cabinet management system. It helps doctors create and manage patient profiles by securely reading information from biometric identity cards.
            </p>

            <h4>Data Processing</h4>
            <p>
              The application processes information obtained from biometric identity cards, including identity information required to create unique patient profiles within the healthcare management system.
            </p>

            <h4>Purpose of Data Processing</h4>
            <p>The collected information is used exclusively to:</p>
            <ul>
              <li>identify patients,</li>
              <li>create and manage patient profiles,</li>
              <li>support doctors in managing their medical practice.</li>
            </ul>

            <h4>Data Sharing</h4>
            <p>
              We do not sell, rent, or share patient information with third parties for advertising or commercial purposes. Data is only processed within the healthcare management system and according to applicable privacy and healthcare regulations.
            </p>

            <h4>Data Security</h4>
            <p>
              We implement appropriate technical and organizational measures to protect patient information against unauthorized access, loss, or misuse.
            </p>

            <h4>Data Retention</h4>
            <p>
              Patient data retention is managed according to the policies of the healthcare management system and applicable legal requirements.
            </p>

            <h4>Contact</h4>
            <p>
              For any questions regarding this privacy policy or data protection, please contact:<br />
              Doctolik<br />
              contact@doctolik.com
            </p>

            <p>Last updated: 19.07.2026</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DocumentationScan;
